export enum EPeriod {
  today = 'TODAY',
  last7days = 'LAST_WEEK',
  lastMonth = 'LAST_MONTH',
}
